import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const useItemListState = (data, prop, updated) => {
  const controllerData = get(data, prop);
  const items = controllerData?.getCollectionData();
  const shown = controllerData?.getCollectionDataLength();
  const size = controllerData?.getCollectionSize();
  const hasMore = controllerData?.getCollectionHasMore();

  const startingWith = controllerData?.getRequestsStartingWith();
  const filter = controllerData?.getRequestsFilterName();
  const orderBy = controllerData?.getRequestsOrderBy();
  const isDescending = controllerData?.getRequestsIsDescending();

  const [toggleSelection, setToggleSelection] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [toggleBulkActions, setToggleBulkActions] = useState(false);
  const [countOfSelectedItems, setCountOfSelectedItems] = useState(0);

  useEffect(() => {
    setToggleSelection(false);
    setAllSelected(false);
    setToggleBulkActions(false);
    setCountOfSelectedItems(0);
  }, [updated]);

  const getSelection = controllerData?.getCollectionSelection;
  const getIsSelected = controllerData?.getCollectionIsSelected;

  const getIsOrdered = (field, isDefault) => {
    return field === orderBy || (isDefault && !orderBy);
  };

  const getOrderAndDirection = (field, upClass, downClass) => {
    if (field !== orderBy) {
      return downClass;
    }
    return isDescending ? upClass : downClass;
  };

  const getWillBeTaxing = () => controllerData?.getWillBeTaxing();

  const onItemSelect = (e, id) => {
    controllerData?.setCollectionSelection(id);
    if (id === 'ALL') {
      setToggleSelection(!toggleSelection);
      setAllSelected(items?.length === controllerData?.getCollectionSelection()?.length);
    }
    if (id !== 'ALL' && toggleSelection && allSelected) {
      setAllSelected(!allSelected);
    }
    if (!controllerData?.getCollectionSelection()?.length) {
      setToggleSelection(false);
      setAllSelected(false);
    }
    setToggleBulkActions(controllerData?.getCollectionSelection()?.length > 0);
    setCountOfSelectedItems(controllerData?.getCollectionSelection()?.length);
  };

  return {
    controllerData,
    items,
    shown,
    size,
    hasMore,
    startingWith,
    filter,
    orderBy,
    isDescending,
    toggleSelection,
    allSelected,
    toggleBulkActions,
    countOfSelectedItems,
    getSelection,
    getIsSelected,
    getIsOrdered,
    getOrderAndDirection,
    getWillBeTaxing,
    onItemSelect
  };
};

useItemListState.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  prop: PropTypes.string.isRequired,
  updated: PropTypes.string
};

useItemListState.defaultProps = {
  updated: undefined
};

export default useItemListState;
